export default __webpack_public_path__ + "static/media/ico_pass.12335713.png";